import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../../../../shared/hooks';
import { LOGIN } from '../../../shared/constants';

const PrivateRoute = () => {
  const { loading, user } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return user === null ? <Navigate to={LOGIN} /> : <Outlet />;
};

export default PrivateRoute;
